
export type LoadingState = 'loading' | 'loaded' | 'error' | null

/** Upper bound on the companies fetched for an optimisation pool. */
export const TSP_COMPANIES_LIMIT = 5_000;

export interface OptimizeCompany {
	id: number,
	lat: number,
	lng: number,
	name?: string
}

export interface MapEvent {
	companyId: number
	eventId: string | number
	eventName: string
	companyName: string
	lat: number
	lng: number
	time: moment.Moment
	noLink?: boolean
	noIndex?: boolean
	color?: string
	/** Optional icon name (Lucide icon name, e.g. 'Clock') to overlay
	 * inside the EventPin's MapPin. When set, EventPin renders `MapPinWithImage`
	 * instead of the bare `MapPin`, so the event shows a special icon while
	 * still using the standard pin shape (hover-blacken, position badge below
	 * the pin all keep working). */
	pinImageString?: string
}

export type MapEventOptions = {
	events: MapEvent[],
	lineColor?: string,
	eventType?: number
}

export interface Position {
	lat: number
	lng: number
}

export interface Interconnection {
	fromWaypoint: string
	toWaypoint: string
	time: number
}
